import React from 'react';
import { createUser, fetchUsers, type User } from '../services/usersApi';

export default function UsersExamplePage() {
  const [users, setUsers] = React.useState<User[]>([]);
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);

  async function loadUsers() {
    try {
      setLoading(true);
      setError(null);
      const data = await fetchUsers();
      setUsers(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not load users');
    } finally {
      setLoading(false);
    }
  }

  React.useEffect(() => {
    loadUsers();
  }, []);

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault();

    try {
      setError(null);
      const newUser = await createUser({ name, email });
      setUsers((currentUsers) => [newUser, ...currentUsers]);
      setName('');
      setEmail('');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not create user');
    }
  }

  return (
    <div className="page heroPage">
      <div className="container">
        <div className="pageHeader">
          <div className="kicker">Backend example</div>
          <h1 className="h1">Users from PostgreSQL</h1>
          <p className="sub">This page shows how React can call your Express API.</p>
        </div>

        <div className="grid cols2" style={{ alignItems: 'start' }}>
          <section className="card">
            <h2 className="cardTitle">Create user</h2>
            <form className="formRow" style={{ marginTop: 12 }} onSubmit={handleSubmit}>
              <label>
                <div className="label">Name</div>
                <input className="input" value={name} onChange={(event) => setName(event.target.value)} required />
              </label>
              <label>
                <div className="label">Email</div>
                <input
                  className="input"
                  type="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  required
                />
              </label>
              <button className="btn btnPrimary" type="submit">
                Add user
              </button>
            </form>
          </section>

          <section className="card">
            <h2 className="cardTitle">Users</h2>
            {loading && <p className="muted">Loading users...</p>}
            {error && <p className="badge badgeWarn">{error}</p>}
            {!loading && !error && (
              <div className="grid" style={{ marginTop: 12 }}>
                {users.map((user) => (
                  <div key={user.id} className="card" style={{ boxShadow: 'none' }}>
                    <strong>{user.name}</strong>
                    <div className="muted">{user.email}</div>
                    <span className="badge badgeAccent" style={{ marginTop: 8 }}>
                      {user.role}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </section>
        </div>
      </div>
    </div>
  );
}
